import { Component } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { map, Observable, Subscription } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';

@Component({
  selector: 'app-baseries-comparision',
  templateUrl: './baseries-comparision.component.html',
  styleUrl: './baseries-comparision.component.scss',
  standalone: false
})
export class BaseriesComparisionComponent {
  activeLanguage!: string;
  latestDocUrl$: Observable<string>;
  subscription = new Subscription();
  constructor(private documentService: GetDocumentService,
    private languageService: LanguageService
  ) {

  }
  ngOnInit() {
    this.subscription.add(this.languageService.getActive().subscribe((lan) => {
      this.activeLanguage = lan;
    }));
    this.latestDocUrl$ = this.documentService.getDocumentByDocumentCode('BW8223').pipe(
      map((response: { url: string }) => response.url)
    );
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}

